// Import por defecto y no con nombre: webpack rechaza el named export de un
// modulo JSON. Asi package.json sigue siendo la unica fuente de la version.
import packageJson from '../../../package.json';
import { buildInfo } from 'src/environment/build-info';

function formatBuildDate(isoDate: string): string {
    const date = new Date(isoDate);
    // Sin las opciones explicitas, es-ES da '10/9/2026' en vez de '10/09/2026'.
    return isNaN(date.getTime())
        ? ''
        : date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function buildLabel(): string {
    // Produccion sella el tag de la release, que ya es la version completa.
    const version = buildInfo.version
        || (buildInfo.number ? `${packageJson.version}.${buildInfo.number}` : packageJson.version);
    const date = formatBuildDate(buildInfo.date);
    return date ? `v${version} · ${date}` : `v${version}`;
}

// Version que se muestra en la pantalla de login: 'v1.3.6 · 24/09/2026' en produccion
// (el tag de la release), 'v1.3.42 · 10/09/2026' en release (package.json mas el
// contador del workflow) y 'v1.3' a secas en local.
export const appVersionLabel: string = buildLabel();
